<template>
  <div class="terms-container">
    <div class="gradient-background">
      <div class="content">
        <button class="back-button" @click="goBack">
          <i class="fa fa-chevron-left"></i>
        </button>

        <button class="login-button" @click="goToLogin">
          Iniciar sesión
        </button>

        <img src="/assets/Logo.png" alt="Mistock.co Logo" class="logo">
        <h1 class="title">Política de Privacidad</h1>
        <div class="terms-content">
          <h2>Política de Privacidad de mistock.co</h2>
          
          <h2>1. Información que Recopilamos</h2>
          <p>En mistock.co, recopilamos la siguiente información para proporcionar y mejorar nuestros servicios de gestión de producción:
            <ul>
              <li>Información de la empresa y contacto comercial</li>
              <li>Datos de producción e inventario</li>
              <li>Registros de procesos y operaciones</li>
              <li>Información de usuarios y roles asignados</li>
              <li>Datos de proveedores y materias primas</li>
              <li>Registros de productos terminados</li>
            </ul>
          </p>

          <h2>2. Uso de la Información</h2>
          <p>Utilizamos la información recopilada para:
            <ul>
              <li>Gestionar y optimizar los procesos de producción</li>
              <li>Proporcionar análisis y reportes de producción</li>
              <li>Mejorar la eficiencia operativa</li>
              <li>Mantener la seguridad de la plataforma</li>
              <li>Enviar actualizaciones importantes del servicio</li>
              <li>Brindar soporte técnico</li>
            </ul>
          </p>

          <h2>3. Protección de Datos</h2>
          <p>mistock.co implementa medidas de seguridad robustas para proteger su información:
            <ul>
              <li>Encriptación de datos sensibles</li>
              <li>Acceso controlado a la información</li>
              <li>Monitoreo continuo de seguridad</li>
              <li>Copias de seguridad regulares</li>
              <li>Protocolos de autenticación seguros</li>
            </ul>
          </p>

          <h2>4. Compartir Información</h2>
          <p>No compartimos su información con terceros excepto en las siguientes circunstancias:
            <ul>
              <li>Con su consentimiento explícito</li>
              <li>Para cumplir con requisitos legales</li>
              <li>Con proveedores de servicios autorizados que nos ayudan a operar</li>
              <li>En caso de fusión o adquisición empresarial</li>
            </ul>
          </p>

          <h2>5. Derechos del Usuario</h2>
          <p>Como usuario de mistock.co, usted tiene derecho a:
            <ul>
              <li>Acceder a sus datos almacenados</li>
              <li>Corregir información inexacta</li>
              <li>Solicitar la eliminación de datos</li>
              <li>Exportar su información</li>
              <li>Revocar consentimientos previos</li>
            </ul>
          </p>

          <h2>6. Retención de Datos</h2>
          <p>Mantenemos su información mientras su cuenta esté activa o según sea necesario para proporcionar nuestros servicios. Puede solicitar la eliminación de sus datos en cualquier momento, sujeto a requisitos legales de retención.</p>

          <h2>7. Cookies y Tecnologías Similares</h2>
          <p>Utilizamos cookies y tecnologías similares para mejorar la experiencia del usuario, analizar el uso del servicio y personalizar el contenido. Puede controlar estas preferencias en la configuración de su navegador.</p>

          <h2>8. Cambios en la Política</h2>
          <p>Nos reservamos el derecho de actualizar esta política de privacidad en cualquier momento. Los cambios significativos serán notificados a través de la plataforma o por correo electrónico.</p>

          <h2>9. Seguridad de Datos Industriales</h2>
          <p>Entendemos la sensibilidad de los datos de producción industrial y mantenemos estrictos protocolos de seguridad para proteger su información comercial confidencial.</p>

          <h2>10. Contacto</h2>
          <p>Si tiene preguntas sobre nuestra política de privacidad o el manejo de sus datos, puede contactarnos a través de nuestro equipo de soporte en la plataforma.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const body = document.getElementsByTagName("body")[0];

export default {
  name: 'Privacy',
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goToLogin() {
      this.$router.push({ name: 'Login' });
    },
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
}
</script>

<style scoped>
.terms-container {
  min-height: 100vh;
  font-family: Arial, sans-serif;
}

.gradient-background {
  background: linear-gradient(to bottom, #706f6f, #4a4949, #2c2c2c);
  min-height: 100vh;
  padding: 20px;
}

.content {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  position: relative;
}

.back-button {
  position: absolute;
  top: 20px;
  left: 20px;
  background: none;
  border: none;
  color: #f9b000;
  font-size: 24px;
  cursor: pointer;
}

.logo {
  width: 100px;
  height: 100px;
  object-fit: contain;
  margin: 0 auto 30px;
  display: block;
}

.title {
  font-size: 28px;
  color: #f9b000;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
}

.terms-content {
  color: #fff;
  margin-bottom: 30px;
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 15px;
}

.terms-content h2 {
  color: #f9b000;
  font-size: 20px;
  margin-top: 20px;
  margin-bottom: 10px;
}

.terms-content p {
  margin-bottom: 15px;
  line-height: 1.6;
}

.terms-content ul {
  margin-left: 20px;
  margin-bottom: 15px;
}

.terms-content li {
  margin-bottom: 5px;
}

.terms-content::-webkit-scrollbar {
  width: 8px;
}

.terms-content::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}

.terms-content::-webkit-scrollbar-thumb {
  background-color: #f9b000;
  border-radius: 4px;
}

.login-button {
  position: absolute;
  top: 30px;
  right: 20px;
  background: none;
  border: none;
  color: #f9b000;
  font-size: 16px;
  cursor: pointer;
}
</style>